import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@saucelabs/sl-component-buttons';
import CopyText from '@saucelabs/sl-component-copy-text';
import { Row, Col } from '@saucelabs/sl-component-grid';
import modalConnect from '@saucelabs/sl-container-modal';
import { Modal } from '@saucelabs/sl-component-overlay';

const MOBILE_MANUAL_SHARE_SESSION_MODAL_KEY = 'mobileManualShareSessionModal';
class MobileManualShareSessionModal extends Component {
  constructor() {
    super();
    this.state = { link: null };
  }

  showShareSessionLink = () => {
    const { requestShareLink } = this.props;

    return requestShareLink().then((link) => this.setState({ link }));
  }

  render() {
    const { onHide, show } = this.props;
    const { link } = this.state;

    return (
      <Modal
        onHide={onHide}
        show={show}
      >
        <Modal.Header>
          <Modal.Title>Share Device</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs>
              {link ? (
                <div>
                  <p>Share this device with others using this link:</p>
                  <CopyText text={link} />
                </div>
              ) : (
                <div>
                  <p>
                    Sharing a device will generate a unique link which you can give to
                    others so they can see the screen of this device.
                  </p>
                  <Button
                    category="primary"
                    material
                    onClick={this.showShareSessionLink}
                    raised
                  >
                    Get Link
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            category="default"
            material
            onClick={onHide}
            size="sm"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

MobileManualShareSessionModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  requestShareLink: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default modalConnect(MOBILE_MANUAL_SHARE_SESSION_MODAL_KEY, MobileManualShareSessionModal);
export {
  MobileManualShareSessionModal,
  MOBILE_MANUAL_SHARE_SESSION_MODAL_KEY,
};
